// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'face-blank';

export const Component = () => (
  <path
    fillRule='evenodd'
    d='M20.63 4.37C22.878 6.614 24 9.31 24 12.5c0 3.19-1.123 5.885-3.37 8.13C18.386 22.878 15.69 24 12.5 24c-3.19 0-5.885-1.123-8.13-3.37C2.122 18.386 1 15.69 1 12.5c0-3.19 1.123-5.885 3.37-8.13C6.614 2.122 9.31 1 12.5 1c3.19 0 5.885 1.123 8.13 3.37Zm2.472 8.13c0-2.157-.584-4.133-1.752-5.93a10.945 10.945 0 0 0-4.762-3.907c-1.976-.853-3.998-1.034-6.109-.63-2.111.405-3.953 1.393-5.48 2.921-1.483 1.482-2.471 3.28-2.875 5.39-.45 2.111-.27 4.178.584 6.154.808 1.976 2.111 3.549 3.908 4.761 1.752 1.213 3.728 1.797 5.885 1.797 2.92 0 5.39-1.033 7.456-3.1 2.067-2.021 3.1-4.537 3.145-7.456Zm-13.274-.795a.993.993 0 0 0 .282-.689V10H8.188v1.016c0 .246.094.492.281.689a.906.906 0 0 0 .657.295c.28 0 .514-.099.702-.295Zm6.703 0a.996.996 0 0 0 .281-.689V10H14.89v1.016c0 .246.094.492.282.689a.932.932 0 0 0 1.359 0ZM7 15h11v1.5H7V15Z'
  />
);

export const viewBox = '0 0 25 25';
